import axios from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
///////////////// requires two parameters
/////////////////  1. _id
/////////////////  2. params example /user or /appbanner
export const handleDelete = async (id, url) => {
  // console.log("id for delete : ", id);
  try {
    const token = localStorage.getItem("token");

    const baseUrl = import.meta.env.VITE_BASE_URL;
    const headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };

    // const result = await Swal.fire({
    //   title: "Are you sure?",
    //   text: "You will not be able to recover this post!",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#4d16a4",
    //   cancelButtonColor: "#d33",
    //   confirmButtonText: "Yes, delete it!",
    // });
    // if (result.isConfirmed) {
    const response = await axios.delete(`${baseUrl}${url}/${id}`, {
      headers,
    });
    if (response) {
      // toast.success(response.data.message) ||
      //   toast.success("Deleted successful");
      // Swal.fire("Deleted!", "Your post has been deleted.", "success");
    }
    // }
    //   setRefresh(!refresh)
  } catch (error) {
    // console.error("Error deleting the row:", error);
    // toast.error("Failed to delete");
    Swal.fire("Error!", " There was a problem deleting the post.", "error");
  }
};
